const TZ_CUIABA = 'America/Cuiaba';

export const ensureDate = (value) => {
  if (!value) return new Date();
  if (value instanceof Date) return new Date(value.getTime());
  return new Date(value);
};

export const startOfDayCuiaba = (value) => {
  const dt = ensureDate(value);
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ_CUIABA, year: 'numeric', month: '2-digit', day: '2-digit'
  });
  const [year, month, day] = formatter.format(dt).split('-').map(Number);
  return new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));
};

export const endOfDayCuiaba = (value) => {
  const dt = ensureDate(value);
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ_CUIABA, year: 'numeric', month: '2-digit', day: '2-digit'
  });
  const [year, month, day] = formatter.format(dt).split('-').map(Number);
  return new Date(Date.UTC(year, month - 1, day, 23, 59, 59, 999));
};

export const startOfWeekCuiaba = (date) => {
  const monday = startOfDayCuiaba(date);
  const dayOfWeek = new Intl.DateTimeFormat('en-US', {
    timeZone: TZ_CUIABA, weekday: 'short'
  }).format(ensureDate(date));
  const map = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  const diff = map[dayOfWeek] - 1;
  const daysToSubtract = diff >= 0 ? diff : 6;
  monday.setUTCDate(monday.getUTCDate() - daysToSubtract);
  return monday;
};

export const endOfWeekCuiaba = (date) => {
  const monday = startOfWeekCuiaba(date);
  const saturday = new Date(monday);
  saturday.setUTCDate(monday.getUTCDate() + 5);
  return endOfDayCuiaba(saturday);
};

export const toCuiabaTimestamp = (value) => {
  const date = ensureDate(value);
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ_CUIABA, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
  });
  const formatted = formatter.format(date);
  const [ymd, time] = formatted.split(', ');
  const [year, month, day] = ymd.split('-').map(Number);
  const [hour, minute, second] = time.split(':').map(Number);
  return Date.UTC(year, month - 1, day, hour, minute, second);
};

export const formatHoraCuiaba = (value) => {
  const data = ensureDate(value);
  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: TZ_CUIABA, hour: '2-digit', minute: '2-digit'
  }).format(data);
};

export const formatDataCuiaba = (value) => {
  const data = ensureDate(value);
  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: TZ_CUIABA, day: '2-digit', month: '2-digit', year: 'numeric'
  }).format(data);
};

export const formatDataKeyCuiaba = (value) => {
  const data = ensureDate(value);
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ_CUIABA, day: '2-digit', month: '2-digit', year: 'numeric'
  }).format(data);
};

export const normalizarComanda = (comanda = {}, fallback = {}) => {
  const baseData = comanda.dataLancamentoISO || comanda.data || comanda.createdAt || Date.now();
  const dataReferencia = ensureDate(baseData);
  const servicosNormalizados = Array.isArray(comanda.servicos)
    ? comanda.servicos.map((servico) => ({
        ...servico,
        preco: parseFloat(servico.preco) || 0,
        comissao: servico.comissao !== undefined && servico.comissao !== null
          ? parseFloat(servico.comissao) : servico.comissao ?? null
      }))
    : [];
  const barbeiroNome = comanda.barbeiroNome || comanda.barbeiro?.nome || fallback.barbeiroNome || '';
  return {
    ...comanda, ...fallback,
    total: parseFloat(comanda.total) || 0,
    servicos: servicosNormalizados,
    horaLancamento: comanda.horaLancamento || formatHoraCuiaba(dataReferencia),
    dataLancamento: comanda.dataLancamento || formatDataCuiaba(dataReferencia),
    dataLancamentoISO: comanda.dataLancamentoISO || dataReferencia.toISOString(),
    dataLancamentoKey: comanda.dataLancamentoKey || formatDataKeyCuiaba(dataReferencia),
    barbeiroNome,
    data: comanda.data || dataReferencia.toISOString()
  };
};

export const fmtBRL = (n) => 'R$ ' + (Number(n) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const fmtN = (n) => (Number(n) || 0).toLocaleString('pt-BR');
